import { render, staticRenderFns } from "./EditOtherForms.vue?vue&type=template&id=7c867058"
import script from "./EditOtherForms.vue?vue&type=script&lang=js"
export * from "./EditOtherForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports